import { type SVGProps, useId } from "react";

/** Union Jack, stretched into the 4:3 box shared by every flag in this folder
 * (the flag's own ratio is 2:1) so all flags line up in a list. */
export function FlagGb(props: SVGProps<SVGSVGElement>) {
  // The counter-charged diagonals need a clip path, whose id must stay unique
  // across every rendered instance.
  const clipId = useId();

  return (
    <svg viewBox="0 0 60 45" xmlns="http://www.w3.org/2000/svg" {...props}>
      <clipPath id={clipId}>
        <path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z" />
      </clipPath>
      <g transform="scale(1, 1.5)">
        <rect width="60" height="30" fill="#012169" />
        <path d="M0,0 60,30 M60,0 0,30" stroke="#ffffff" strokeWidth="6" />
        <path
          d="M0,0 60,30 M60,0 0,30"
          clipPath={`url(#${clipId})`}
          stroke="#c8102e"
          strokeWidth="4"
        />
        <path d="M30,0 v30 M0,15 h60" stroke="#ffffff" strokeWidth="10" />
        <path d="M30,0 v30 M0,15 h60" stroke="#c8102e" strokeWidth="6" />
      </g>
    </svg>
  );
}
